import { NgModule } from "@angular/core";
import { PayingLaterCustomerBackend } from "src/app/backend/api/paying-later-customer.backend";
import { CustomerBackend } from "./api/customer.backend";
import { GroupBackend } from "./api/group.backend";
import { RaceBackend } from "./api/race.backend";
import { WardBackend } from "./api/ward/ward.backend";
import { WardMockBackend } from "./api/ward/ward.mock.backend";
import { TicketBackend } from "./api/ticket.backend";
import { AppointmentBackend } from "./api/appointment.backend";
import { AppointmentReasonBackend } from "./api/appointment-reason.backend";
import { CostCenterBackend } from "./api/cost-center.backend";
import { TaxRateBackend } from "./api/tax-rate/tax-rate.backend";
import { TaxRateMockBackend } from "./api/tax-rate/tax-rate.mock.backend";
import { FiscalProfileBackend } from "./api/fiscal-profile.backend";
import { InvoiceBackend } from "./api/invoice.backend";
import { MedicationsBackend } from "./medications/medications-backend";
import { MedicationsMockBackend } from "./medications/medications.mock.backend";
import { mockClassFactory } from "../support/mock";
import { MemberBackend } from "./api/member.backend";
import { HttpClient } from "@angular/common/http";
import { UserBackend } from "./api/user.backend";
import { TemplateReportingBackend } from "./api/template-reporting/template-reporting.backend";
import { TemplateReportingMockBackend } from "./api/template-reporting/template-reporting.mock.backend";
import { TagBackend } from "./api/tag/tag.backend";
import { TemplateEmailBackend } from "./api/template-email/template-email.backend";
import { TemplateEmailMockBackend } from "./api/template-email/template-email.mock.backend";
import { RegistryHeadingBackend } from "./api/registry-heading.backend";
import { FacilityBackend } from "./api/facility.backend";
import { StorageBackend } from "./api/storage/storage.backend";
import { OrganizationBackend } from "./api/organization.backend";
import { PrefixBackend } from "./api/prefix.backend";
import { CredentialBackend } from "./api/credential.backend";
import { MessageBackend } from "./api/message.backend";
import { AttachmentBackend } from "./api/attachment.backend";
import { ResourceBackend } from "./api/resource.backend";
import { RevenueCenterBackend } from "./api/revenue-center.backend";
import { PetBackend } from "./api/pet.backend";
import { ConfigurationBackend } from "./api/configuration.backend";
import { RoomBackend } from "./api/room.backend";
import { AppointmentTemplateBackend } from "./api/appointment-template.backend";
import { ServiceBackend } from "./api/service.backend";
import { MastercaseBackend } from "./api/mastercase.backend";
import { SoapTemplateBackend } from "./api/soap-template.backend";
import { DocumentBackend } from "./api/document.backend";
import { HealthRecordBackend } from "./api/health-record.backend";
import { CartBackend } from "./api/cart.backend";
import { RateTableBackend } from "./api/rate-table/rate-table.backend";
import { MedicalServiceBackend } from "./api/medical-service/medical-service.backend";
import { WorkOrderBackend } from "./api/work-order/work-order.backend";
import { DrugBackend } from "./api/drug.backend";
import { ProductBackend } from "./api/product.backend";
import { TaskBackend } from "./api/task.backend";
import { QuoteBackend } from "./api/quote.backend";
import { BookBackend } from "./api/book.backend";
import { FormularyBackend } from "src/app/backend/api/formulary.backend";
import { PrescriptionBackend } from "src/app/backend/api/prescription.backend";
import { PackagingBackend } from "src/app/backend/api/packaging.backend";
import { QuoteTemplateBackend } from "src/app/backend/api/quote-template.backend";
import { ExportBackend } from "src/app/backend/api/export.backend";
import { PaymentMethodBackend } from "src/app/backend/api/payment-method.backend";
import { BankAccountBackend } from "src/app/backend/api/bank-account.backend";
import { ReminderBackend } from "src/app/backend/api/reminder.backend";
import { AnalyticsSalesBackend } from "src/app/backend/api/analytics-sales.backend";
import { RecoveryBackend } from "src/app/backend/api/recovery.backend";
import { PassiveInvoiceBackend } from "src/app/backend/api/passive-invoice.backend";
import { ToolkitBackend } from "src/app/backend/api/toolkit.backend";
import { ReminderTemplateBackend } from "src/app/backend/api/reminder-template.backend";
import { VaccineBackend } from "src/app/backend/api/vaccine.backend";
import { LetterheadBackend } from "src/app/backend/api/letterhead/letterhead.backend";
import { SoftwareProduct } from "src/app/support/product";
import { PmsLetterheadBackend } from "src/app/backend/api/letterhead/pms-letterhead.backend";
import { RocketLetterheadBackend } from "src/app/backend/api/letterhead/rocket-letterhead.backend";
import { AttachmentDirectoryBackend } from "src/app/backend/api/attachment-directory.backend";
import { AnalyticsIncomesBackend } from "src/app/backend/api/analytics-incomes.backend";
import { PhysicianBackend } from "src/app/backend/api/physician.backend";
import { SpeciesBackend } from "src/app/backend/api/species.backend";
import { AnalyticsCustomersBackend } from "src/app/backend/api/analytics-customers.backend";
import { AnalyticsPatientsBackend } from "src/app/backend/api/analytics-patients.backend";
import { CoatBackend } from "./api/coat.backend";
import { BookItemBackend } from "src/app/backend/api/book-item.backend";
import { RoleBackend } from "src/app/backend/api/role.backend";
import { ShiftBackend } from "src/app/backend/api/shift.backend";
import { TenantBackend } from "src/app/backend/api/tenant.backend";
import { ImportBackend } from "src/app/backend/api/import.backend";
import { AnalyticsTicketsBackend } from "src/app/backend/api/analytics-tickets.backend";
import { AnalyticsRemindersBackend } from "src/app/backend/api/analytics-reminders.backend";
import { WarehouseBackend } from "src/app/backend/api/warehouse.backend";
import { CashClosureBackend } from "src/app/backend/api/cash-closure.backend";
import { CatalogBackend } from "src/app/backend/api/catalog.backend";
import { RemunerationBackend } from "src/app/backend/api/remuneration.backend";
import { SurveyBackend } from "src/app/backend/api/survey.backend";
import { DomainBackend } from "src/app/backend/api/domain.backend";
import { AccountBackend } from "src/app/backend/api/account.backend";
import { BabelBackend } from "src/app/backend/api/babel.backend";
import { EnigmaBackend } from "src/app/backend/api/enigma.backend";
import { AttachmentBillingBackend } from "src/app/backend/api/attachment-billing.backend";
import { VilmaBackend } from "src/app/backend/api/vilma.backend";
import { AlarmBackend } from "src/app/backend/api/alarm.backend";
import { IntegrationBackend } from "src/app/backend/api/integration.backend";
import { InstallationBackend } from "src/app/backend/api/installation.backend";
import { AnalyticsStudiesBackend } from "src/app/backend/api/analytics-studies.backend";
import { CampaignBackend } from "src/app/backend/api/campaign.backend";
import { SegmentationBackend } from "src/app/backend/api/segmentation.backend";
import { QuotaBackend } from "src/app/backend/api/quota.backend";
import { KpiBackend } from "src/app/backend/api/kpi.backend";
import { AnalyticsSurveysBackend } from "src/app/backend/api/analytics-surveys.backend";
import { NotImplementedLetterheadBackend } from "src/app/backend/api/letterhead/not-implemented-letterhead.backend";
import { OrderBackend } from "src/app/backend/api/order.backend";
import { OrderServiceBackend } from "src/app/backend/api/order-service.backend";
import { ProductService } from "src/app/services/product.service";

@NgModule({
  imports: [],
  providers: [
    {
      provide: LetterheadBackend,
      deps: [HttpClient, ProductService],
      useFactory: (http: HttpClient, productService: ProductService) => {
        switch (productService.getCurrentProduct()) {
          case SoftwareProduct.PMS: {
            return new PmsLetterheadBackend(http);
          }
          case SoftwareProduct.ROCKET: {
            return new RocketLetterheadBackend(http);
          }
          case SoftwareProduct.ADMIN:
          case SoftwareProduct.PLATFORM:
          case SoftwareProduct.DROP_PAGE:
          case SoftwareProduct.BOTMASTER: {
            return new NotImplementedLetterheadBackend();
          }
          default: {
            throw new Error("Invalid software product");
          }
        }
      }
    },
    BabelBackend,
    RemunerationBackend,
    WarehouseBackend,
    CatalogBackend,
    AnalyticsSalesBackend,
    AnalyticsCustomersBackend,
    AnalyticsPatientsBackend,
    AnalyticsTicketsBackend,
    AnalyticsRemindersBackend,
    AnalyticsIncomesBackend,
    AnalyticsStudiesBackend,
    AnalyticsSurveysBackend,
    KpiBackend,
    TicketBackend,
    CredentialBackend,
    MessageBackend,
    AppointmentBackend,
    AttachmentBackend,
    AppointmentReasonBackend,
    CustomerBackend,
    RoleBackend,
    PetBackend,
    DrugBackend,
    PackagingBackend,
    ProductBackend,
    CashClosureBackend,
    WorkOrderBackend,
    RateTableBackend,
    MedicalServiceBackend,
    ReminderBackend,
    AlarmBackend,
    {
      provide: MedicationsBackend,
      deps: [],
      useFactory: mockClassFactory<MedicationsBackend>(
        MedicationsMockBackend,
        MedicationsMockBackend
      )
    },
    SpeciesBackend,
    RecoveryBackend,
    RaceBackend,
    CoatBackend,
    ResourceBackend,
    RevenueCenterBackend,
    CostCenterBackend,
    RoomBackend,
    AppointmentTemplateBackend,
    ServiceBackend,
    MastercaseBackend,
    SoapTemplateBackend,
    DocumentBackend,
    HealthRecordBackend,
    CartBackend,
    BookBackend,
    BookItemBackend,
    FormularyBackend,
    PrescriptionBackend,
    PaymentMethodBackend,
    BankAccountBackend,
    PassiveInvoiceBackend,
    ReminderTemplateBackend,
    PhysicianBackend,
    ShiftBackend,
    DomainBackend,
    AccountBackend,
    TenantBackend,
    OrderBackend,
    EnigmaBackend,
    {
      provide: TaxRateBackend,
      deps: [],
      useFactory: mockClassFactory<TaxRateBackend>(
        TaxRateMockBackend,
        TaxRateMockBackend
      )
    },
    FiscalProfileBackend,
    ExportBackend,
    ImportBackend,
    InvoiceBackend,
    QuoteBackend,
    QuoteTemplateBackend,
    MemberBackend,
    GroupBackend,
    UserBackend,
    OrganizationBackend,
    ConfigurationBackend,
    VaccineBackend,
    VilmaBackend,
    {
      provide: TemplateReportingBackend,
      deps: [HttpClient],
      useFactory: mockClassFactory<TemplateReportingBackend>(
        TemplateReportingMockBackend,
        TemplateReportingMockBackend
      )
    },
    {
      provide: TemplateEmailBackend,
      deps: [],
      useFactory: mockClassFactory<TemplateEmailBackend>(
        TemplateEmailMockBackend,
        TemplateEmailMockBackend
      )
    },
    RegistryHeadingBackend,
    {
      provide: TagBackend,
      deps: [HttpClient],
      useFactory: (httpClient: HttpClient) => new TagBackend(httpClient)
    },
    {
      provide: WardBackend,
      deps: [],
      useFactory: mockClassFactory<WardBackend>(
        WardMockBackend,
        WardMockBackend
      )
    },
    FacilityBackend,
    {
      provide: StorageBackend,
      deps: [HttpClient],
      useClass: StorageBackend
    },
    PrefixBackend,
    TaskBackend,
    ToolkitBackend,
    AttachmentDirectoryBackend,
    AttachmentBillingBackend,
    SurveyBackend,
    IntegrationBackend,
    InstallationBackend,
    CampaignBackend,
    SegmentationBackend,
    QuotaBackend,
    OrderServiceBackend,
    PayingLaterCustomerBackend
  ]
})
export class BackendModule {}
